<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.hspbrands.com/"
        target="_blank">HSP Brands</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/analytics' },
      { name: 'HSP', Link: 'https://www.hspbrands.com/', target: '_blank' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
